module.exports = __webpack_public_path__ + "img/ctrl-a-stub-up--i.55b61718.svg";